/* Impression SCDM — L ADRESSE COURRIEL ET LE TELEPHONE A L ABRI DES ROBOTS.

   LE PROBLEME. Une adresse ecrite en clair dans une page est ramassee en
   quelques jours par les robots moissonneurs, qui balaient le web a la
   recherche du motif « quelque chose arobase quelque chose point quelque
   chose ». Une fois l adresse dans leurs listes, elle y reste : on ne la
   retire plus, on change d adresse. Le lien « mailto: » est encore pire,
   parce qu il annonce lui-meme qu il contient une adresse.

   CE QU ON FAIT ICI, ET POURQUOI CA MARCHE.

   1. L ADRESSE N EXISTE EN CLAIR NULLE PART. Ni dans le HTML servi, ni dans
      ce fichier. Elle est coupee en morceaux et l arobase est un code de
      caractere. Un robot qui lit la page ou le fichier avec une expression
      reguliere ne trouve rien a moissonner — il n y a litteralement rien qui
      ressemble a une adresse.

   2. IL FAUT UN GESTE HUMAIN. L adresse ne s assemble qu apres un clic ET une
      petite question. La quasi-totalite des moissonneurs n executent meme pas
      le JavaScript : pour eux la page ne contient qu un bouton. Ceux qui
      l executent ne cliquent pas et ne repondent pas.

   3. LA QUESTION EST ECRITE EN LETTRES. « trois plus quatre », pas « 3 + 4 ».
      Un robot qui saurait lire un calcul en chiffres bute sur les mots.

   CE QU ON NE FAIT PAS. Pas de CAPTCHA a images, pas de service tiers, pas de
   cookie. Une seule question, une seule fois par visite : une fois repondue,
   toutes les adresses de la page se devoilent d un coup et le reste de la
   visite ne redemande rien.

   PERSONNE N EST BLOQUE. Le formulaire de soumission n a jamais eu besoin ni de
   l adresse ni du telephone pour fonctionner, et c est meme la meilleure facon
   de nous joindre : il transporte les fichiers du client. Quelqu un qui refuse
   le JavaScript ou qui ne veut pas repondre a la question passe par la, et la
   question elle-meme le lui dit.

   COMMENT S EN SERVIR AILLEURS DANS LE CODE.

   - Dans une page ou un gabarit : poser <span data-scdm-courriel></span> ou
     <span data-scdm-tel></span> a l endroit voulu. Le reste se fait tout seul.
   - Dans un lien : ecrire <a href="mailto:..." > normalement ; ce fichier le
     desamorce au chargement et le remet en etat apres la verification, avec
     son sujet et son corps pre-remplis s il en avait.
   - Dans un autre script : appeler window.SCDM_COURRIEL() ou window.SCDM_TEL()
     — qui retournent la coordonnee assemblee — plutot que de la reecrire.

   SI L ADRESSE OU LE NUMERO CHANGE : quelques lignes a modifier, BOITE,
   DOMAINE et T1/T2/T3 ci-dessous. Rien d autre dans tout le site.

   Charge depuis snippets/scdm-minimum.liquid, en defer, sur toutes les pages.
*/

(function () {
  'use strict';

  /* ------------------------------------------------------------ l adresse */

  /* Coupee en trois. Aucune de ces chaines ne ressemble a une adresse, et
     l arobase n est pas ecrite : c est le caractere 64. */
  var BOITE   = 'info';
  var DOMAINE = 'impressionscdm' + '.' + 'com';
  function adresse() { return BOITE + String.fromCharCode(64) + DOMAINE; }

  /* Les autres scripts du site passent par ici au lieu de reecrire l adresse. */
  window.SCDM_COURRIEL = adresse;

  /* LE TELEPHONE SUIT LA MEME REGLE. Les robots moissonnent aussi les numeros,
     pour les listes d appels automatises et les envois de textos. Il est donc
     coupe en trois lui aussi, et il ne s assemble qu apres la verification.
     Les separateurs ne sont pas ecrits : ce sont des codes de caractere, pour
     qu aucune suite de dix chiffres ne traine dans le fichier. */
  var T1 = '418', T2 = '487', T3 = '6540';
  var TIRET = String.fromCharCode(45);
  function telephone() { return T1 + TIRET + T2 + TIRET + T3; }
  function telLien() { return 'tel:' + String.fromCharCode(43) + '1' + T1 + T2 + T3; }
  window.SCDM_TEL = telephone;

  /* ---------------------------------------------------------- la question */

  /* En lettres, jamais en chiffres. Deux nombres entre 2 et 9, tires au sort
     a chaque chargement : la reponse n est pas la meme d une visite a l autre,
     donc elle ne peut pas etre apprise par coeur. */
  var MOTS = ['zero', 'un', 'deux', 'trois', 'quatre', 'cinq',
              'six', 'sept', 'huit', 'neuf'];

  function tirer() { return 2 + Math.floor(Math.random() * 8); }
  var A = tirer(), B = tirer();
  function bonneReponse() { return A + B; }

  /* ------------------------------------------------------------- memoire */

  /* Une seule verification par visite. sessionStorage et pas localStorage :
     ca s efface a la fermeture de l onglet, on ne garde rien sur la duree. */
  var CLE = 'scdm-humain';

  function dejaVerifie() {
    try { return sessionStorage.getItem(CLE) === '1'; } catch (e) { return false; }
  }
  function retenir() {
    try { sessionStorage.setItem(CLE, '1'); } catch (e) { /* navigation privee */ }
  }

  /* --------------------------------------------------------------- style */

  function style() {
    if (document.getElementById('scdmCourrielStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmCourrielStyle';
    s.textContent = [
      '.scdm-mail{display:inline-block;max-width:100%}',
      '.scdm-mail-btn{display:inline-flex;align-items:center;gap:7px;',
      'background:none;border:1px dashed currentColor;border-radius:8px;',
      'padding:5px 11px;font:inherit;font-size:.95em;color:inherit;',
      'cursor:pointer;opacity:.92;line-height:1.35}',
      '.scdm-mail-btn:hover{opacity:1;border-style:solid}',
      '.scdm-mail-btn .cad{font-size:1.05em;line-height:1}',
      '.scdm-mail-q{display:block;margin:9px 0 0;padding:11px 13px;',
      'border-radius:10px;border:1px solid rgba(128,128,128,.38);',
      'background:rgba(128,128,128,.08);font-size:13px;line-height:1.5;',
      'max-width:340px}',
      '.scdm-mail-q p{margin:0 0 8px}',
      '.scdm-mail-q .rang{display:flex;gap:7px;align-items:center;flex-wrap:wrap}',
      '.scdm-mail-q input{width:74px;padding:7px 9px;font:inherit;font-size:14px;',
      'border:1px solid rgba(128,128,128,.55);border-radius:7px;',
      'background:#fff;color:#1A1A1A}',
      '.scdm-mail-q button{padding:7px 13px;font:inherit;font-size:13px;',
      'font-weight:600;border:none;border-radius:7px;cursor:pointer;',
      'background:#A83700;color:#fff}',
      '.scdm-mail-q .err{display:block;margin:7px 0 0;color:#C0392B;font-weight:600}',
      '.scdm-mail-q .alt{display:block;margin:8px 0 0;opacity:.8;font-size:12.5px}',
      '.scdm-mail-q[hidden]{display:none !important}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ==================================================================
     LE REGISTRE DES ENDROITS A DEVOILER
     Chaque entree sait se remettre en etat toute seule quand la
     verification est passee.
     ================================================================== */

  var portes = [];

  function devoilerTout() {
    retenir();
    portes.forEach(function (p) { p.ouvrir(); });
  }

  /* --------------------------------------------------------- la question */

  function poserLaQuestion(apres, hote) {
    var boite = document.createElement('div');
    boite.className = 'scdm-mail-q';
    boite.setAttribute('role', 'group');

    var p = document.createElement('p');
    p.innerHTML = 'Petite vérification, pour éviter les robots collecteurs d’adresses.<br>' +
                  'Combien font <b>' + MOTS[A] + ' plus ' + MOTS[B] + '</b> ?';

    var rang = document.createElement('div');
    rang.className = 'rang';

    var champ = document.createElement('input');
    champ.type = 'text';
    champ.setAttribute('inputmode', 'numeric');
    champ.setAttribute('autocomplete', 'off');
    champ.setAttribute('aria-label', 'Combien font ' + MOTS[A] + ' plus ' + MOTS[B] + ' ?');

    var ok = document.createElement('button');
    ok.type = 'button';
    ok.textContent = 'Voir l’adresse';

    var err = document.createElement('span');
    err.className = 'err';
    err.hidden = true;

    var alt = document.createElement('span');
    alt.className = 'alt';
    /* On ne met surtout pas le numero ici : ce serait le donner aux robots par
       la porte d a cote. Le formulaire de soumission n a jamais eu besoin ni de
       l adresse ni du telephone pour fonctionner. */
    alt.innerHTML = 'Vous préférez ne pas répondre ? Passez par la page ' +
                    '<a href="/pages/soumission">Demander une soumission</a> — ' +
                    'elle nous parvient directement, et vous pouvez y joindre vos fichiers.';

    function valider() {
      /* On accepte le nombre ecrit en chiffres comme en lettres : quelqu un
         qui repond « sept » a compris la question aussi bien que « 7 ». */
      var v = (champ.value || '').trim().toLowerCase()
                .replace(/\s+/g, '')
                .replace(/[éèê]/g, 'e');
      var attendu = bonneReponse();
      var enLettres = MOTS[attendu] || '';
      if (v === String(attendu) || (enLettres && v === enLettres) ||
          (attendu === 10 && v === 'dix') || (attendu === 11 && v === 'onze') ||
          (attendu === 12 && v === 'douze') || (attendu === 13 && v === 'treize') ||
          (attendu === 14 && v === 'quatorze') || (attendu === 15 && v === 'quinze') ||
          (attendu === 16 && v === 'seize') || (attendu === 17 && v === 'dixsept') ||
          (attendu === 18 && v === 'dixhuit')) {
        boite.remove();
        devoilerTout();
        if (typeof apres === 'function') apres();
        return;
      }
      err.hidden = false;
      err.textContent = 'Ce n’est pas ça. Réessayez.';
      champ.focus();
      champ.select();
    }

    ok.addEventListener('click', valider);
    champ.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); valider(); }
    });

    rang.appendChild(champ);
    rang.appendChild(ok);
    boite.appendChild(p);
    boite.appendChild(rang);
    boite.appendChild(err);
    boite.appendChild(alt);
    hote.appendChild(boite);
    champ.focus();
    return boite;
  }

  /* ------------------------------------------------------------ le bouton */

  function bouton(texte, picto) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'scdm-mail-btn';
    b.innerHTML = '<span class="cad" aria-hidden="true">' + (picto || '✉') +
                  '</span><span>' + texte + '</span>';
    return b;
  }

  /* ==================================================================
     CAS 1 — UN EMPLACEMENT VIDE : <span data-scdm-courriel></span>
     ================================================================== */

  function poserEmplacement(el) {
    if (el.getAttribute('data-scdm-pose') === '1') return;
    el.setAttribute('data-scdm-pose', '1');
    el.classList.add('scdm-mail');

    var texte = el.getAttribute('data-libelle') || 'Afficher l’adresse courriel';

    function ouvrir() {
      el.textContent = '';
      var a = document.createElement('a');
      a.href = 'mailto:' + adresse();
      a.textContent = adresse();
      el.appendChild(a);
    }

    if (dejaVerifie()) { ouvrir(); return; }

    var b = bouton(texte);
    b.addEventListener('click', function () {
      b.hidden = true;
      poserLaQuestion(null, el);
    });
    el.textContent = '';
    el.appendChild(b);
    portes.push({ ouvrir: ouvrir });
  }

  /* ==================================================================
     CAS 1 bis — UN EMPLACEMENT VIDE POUR LE TELEPHONE
     <span data-scdm-tel></span>
     ================================================================== */

  function poserTelephone(el) {
    if (el.getAttribute('data-scdm-pose') === '1') return;
    el.setAttribute('data-scdm-pose', '1');
    el.classList.add('scdm-mail');

    var texte = el.getAttribute('data-libelle') || 'Afficher le numéro de téléphone';

    function ouvrir() {
      el.textContent = '';
      var a = document.createElement('a');
      a.href = telLien();
      a.textContent = telephone();
      el.appendChild(a);
    }

    if (dejaVerifie()) { ouvrir(); return; }

    var b = bouton(texte, '☎');
    b.addEventListener('click', function () {
      b.hidden = true;
      poserLaQuestion(null, el);
    });
    el.textContent = '';
    el.appendChild(b);
    portes.push({ ouvrir: ouvrir });
  }

  /* ==================================================================
     CAS 2 — UN LIEN mailto: OU tel: DEJA ECRIT DANS LA PAGE
     On lui retire son href (c est lui que le robot cherche) et on garde
     l original de cote, en memoire, pour le remettre apres.
     ================================================================== */

  function desamorcer(a) {
    if (a.getAttribute('data-scdm-pose') === '1') return;
    a.setAttribute('data-scdm-pose', '1');

    var vrai = a.getAttribute('href') || '';
    var etiquette = (a.textContent || '').trim();
    var estTel = /^tel:/i.test(vrai);

    /* Le lien affichait-il la coordonnee elle-meme, ou une phrase ?
       « Écrivez-nous pour être averti » doit rester tel quel une fois
       devoile ; « info@... » doit redevenir l adresse, et une suite de
       chiffres redevenir le numero. */
    var montraitLAdresse = estTel
      ? /\d[\d\s().-]{6,}/.test(etiquette)
      : etiquette.indexOf(String.fromCharCode(64)) !== -1;

    function ouvrir() {
      a.setAttribute('href', vrai);
      a.hidden = false;
      if (montraitLAdresse) a.textContent = estTel ? telephone() : adresse();
      if (porte.b && porte.b.parentNode) porte.b.remove();
    }

    var porte = { ouvrir: ouvrir, b: null };

    if (dejaVerifie()) { ouvrir(); return; }

    /* On enleve le href AVANT tout : tant que la verification n est pas
       passee, il n y a aucun « mailto: » dans la page. */
    a.removeAttribute('href');
    a.hidden = true;

    var b = bouton(
      montraitLAdresse
        ? (estTel ? 'Afficher le numéro de téléphone' : 'Afficher l’adresse courriel')
        : (etiquette || (estTel ? 'Nous appeler' : 'Nous écrire')),
      estTel ? '☎' : '✉');
    porte.b = b;

    var hote = document.createElement('span');
    hote.className = 'scdm-mail';
    a.parentNode.insertBefore(hote, a);
    hote.appendChild(b);

    b.addEventListener('click', function () {
      b.hidden = true;
      poserLaQuestion(function () {
        /* Le client avait clique sur CE lien : on l ouvre pour lui, il n a
           pas a recliquer. */
        if (!montraitLAdresse) a.click();
      }, hote);
    });

    portes.push(porte);
  }

  /* ==================================================================
     LE BALAYAGE
     ================================================================== */

  function balayer(racine) {
    var r = racine || document;
    var vides = r.querySelectorAll ? r.querySelectorAll('[data-scdm-courriel]') : [];
    for (var i = 0; i < vides.length; i++) poserEmplacement(vides[i]);

    var tels = r.querySelectorAll ? r.querySelectorAll('[data-scdm-tel]') : [];
    for (var k = 0; k < tels.length; k++) poserTelephone(tels[k]);

    var liens = r.querySelectorAll
      ? r.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]') : [];
    for (var j = 0; j < liens.length; j++) desamorcer(liens[j]);
  }

  function demarrer() {
    style();
    balayer(document);

    /* Certains encadres arrivent apres coup — la recommandation de vinyle
       phosphorescent, par exemple, pose son lien quand le client charge une
       pancarte d urgence. On surveille donc les ajouts. */
    if (window.MutationObserver) {
      new MutationObserver(function (lots) {
        for (var i = 0; i < lots.length; i++) {
          var aj = lots[i].addedNodes;
          for (var j = 0; j < aj.length; j++) {
            if (aj[j].nodeType !== 1) continue;
            if (aj[j].matches && aj[j].matches('a[href^="mailto:"], a[href^="tel:"]')) desamorcer(aj[j]);
            if (aj[j].matches && aj[j].matches('[data-scdm-courriel]')) poserEmplacement(aj[j]);
            if (aj[j].matches && aj[j].matches('[data-scdm-tel]')) poserTelephone(aj[j]);
            balayer(aj[j]);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
